export const IconHomeFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconHomeFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconHomeFilled_svg__a)">
        <path d="M4 19v-9a1.99 1.99 0 0 1 .8-1.6l6-4.5q.525-.4 1.2-.4t1.2.4l6 4.5q.375.275.588.7T20 10v9q0 .824-.587 1.413A1.93 1.93 0 0 1 18 21h-3a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 20v-5a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 14h-2a.97.97 0 0 0-.713.287A.97.97 0 0 0 10 15v5q0 .424-.287.712A.97.97 0 0 1 9 21H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 19" />
      </g>
    </svg>
  );
};
